import Vue from 'vue';

import store from './store';
import closedCourseApp from './closed-course-app.vue';

export const initClosedCourse = () => {
  const app = document.getElementById('closed-courses-app');

  if (app) {
    const main = document.getElementById('main');
    const { formatid: formatId, categoryid: categoryId } = main.dataset;

    new Vue({
      store,
      render: (h) =>
        h(closedCourseApp, {
          props: {
            formatId,
            categoryId,
          },
        }),
    }).$mount('#closed-courses-app');
  }
};
